export const IMAGE_URL = "https://betaapi.madamg.ai/api/uploads/";
export const apiBaseUrl = "https://betaapi.madamg.ai/api";
// export const apiBaseUrl = "http://localhost:5000/api";
export const beautyBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/beauty";
export const ecommerceBaseUrl =
  "https://betaapi.madamg.ai/api/backend/v1/e-commerce";
export const commonBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/common";
export const wellnessBaseUrl =
  "https://betaapi.madamg.ai/api/backend/v1/wellness";
export const skinBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/skinAi";
// export const IMAGE_URL = 'https://betaapi.madamg.ai';

// export const IMAGE_URL = 'https://betaapi.madamg.ai/api/uploads/';
// export const apiBaseUrl = 'https://betaapi.madamg.ai/api';
// export const beautyBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/beauty";
// export const ecommerceBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/e-commerce";
// export const commonBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/common";
// export const wellnessBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/wellness";
// export const skinBaseUrl = "https://betaapi.madamg.ai/api/backend/v1/skinAi";
export const googleApi = "AIzaSyBE1vb20p5RWGMu4boFq9ldbC_9mdS4VVE";
